import React, { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import tilePdfLogo from "../../img/tilePdfLogo.png";
import { API_URL } from '../../shared/constant';
const Sidebar = () => {
    const location = useLocation();
    const [isAllowed, setIsAllowed] = useState(false)

    const userInfo = () => {
        axios.post(API_URL.LOGIN_USER, {}).then((res) => {
            if (res.data) {
                setIsAllowed(res.data.is_allowed);
            }
        });
    }

    useEffect(() => {
        userInfo();
    }, []);

    return (
        <div className="sidebar hidden-print" id="sidebar">
            <div className="sidebar-header">
                <div className="sidebar-logo m-3">
                    <Link to="/">
                        <img src={tilePdfLogo} className="img-fluid" alt="2" />
                    </Link>
                </div>
            </div>
            <div className="sidebar-inner slimscroll">
                <div id="sidebar-menu" className="sidebar-menu">
                    <ul>
                        <li className={(location.pathname.includes('/admin/dashboard')) ? 'active' : ''}>
                            <Link to="/admin/dashboard"><i className="fe fe-home"></i> <span>Dashboard</span></Link>
                        </li>
                        { isAllowed && <li className={(location.pathname.includes('/admin/user')) ? 'active' : ''}>
                            <Link to="/admin/user"><i className="fe fe-user"></i> <span>User</span></Link>
                        </li> }
                        { isAllowed && <li className={(location.pathname.includes('/admin/size')) ? 'active' : ''}>
                            <Link to="/admin/size"><i className="fe fe-minimize"></i> <span>Size</span></Link>
                        </li> }
                        <li className={(location.pathname.includes('/admin/series')) ? 'active' : ''}>
                            <Link to="/admin/series"><i className="fe fe-edit-3"></i> <span>Series</span></Link>
                        </li>
                        <li className={(location.pathname.includes('/admin/product')) ? 'active' : ''}>
                            <Link to="/admin/product"><i className="fe fe-grid"></i> <span>Product</span></Link>
                        </li>
                        <li className={(location.pathname.includes('/admin/pdf')) ? 'active' : ''}>
                            <Link to="/admin/pdf"><i className="fe fe-file-text"></i> <span>Pdf</span></Link>
                        </li>
                        {/* <li className="submenu" onClick={() => setSetting(!settings)} >
                            <Link to="#"><i className="fe fe-settings"></i> <span> Settings</span> <span className="menu-arrow"></span></Link>
                        </li>
                        {
                            settings && (
                                <>
                                    <li className={(location.pathname.includes('/admin/viewStock')) ? 'active' : ''}>
                                        <Link to="/admin/profile"><span >Profile</span></Link>
                                    </li>
                                </>
                            )
                        } */}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Sidebar;